module.exports = __webpack_public_path__ + "static/assets/340f5a3d6ae326f22b9707104adf6bb9.png";